<template>
  <div v-if="event">

    <!-- Delete sub-view -->
    <DeleteName
      v-if="currentView === 'delete'"
      :name="selectedName"
      @toggleDeleteNameScreen="backToList"
    />

    <!-- Edit sub-view -->
    <EditName
      v-else-if="currentView === 'edit'"
      :name="selectedName"
      @toggleEditNameScreen="backToList"
    />

    <!-- Main list view -->
    <div v-else class="card add-bill-modifier has-rounded-top-corners">
      <div class="card-content add-bill-card-modifier">
        <div class="container has-text-weight-semibold has-text-centered">
          <h3 class="title is-4 has-baskerville-font has-text-brand-color mb-5">
            View As
          </h3>
        </div>
        <div class="container mb-5">
          <label class="label mb-0">Select your name</label>
          <div class="is-size-7 has-text-grey-light mb-3">
            Not found? Add your name below.
          </div>
          <div
            v-for="(nameItem, index) in event.names"
            :key="index"
            class="field has-addons mb-2"
          >
            <div class="control is-expanded">
              <button
                @click="setName(nameItem)"
                class="button is-outlined is-info is-fullwidth name-select-btn"
                :disabled="loading"
              >
                {{ nameItem }}
              </button>
            </div>
            <div class="control">
              <button
                @click="startEdit(nameItem)"
                class="button is-outlined is-info"
                :disabled="loading"
                title="Edit name"
              >
                <span class="icon is-small">
                  <i class="fas fa-pencil-alt"></i>
                </span>
              </button>
            </div>
            <div class="control">
              <button
                @click="startDelete(nameItem)"
                class="button is-outlined is-danger"
                :disabled="loading"
                title="Delete name"
              >
                <span class="icon is-small">
                  <i class="fas fa-trash-alt"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="container">
          <label class="label">Add new name</label>
          <div class="control">
            <input
              class="input"
              v-bind:class="{'is-loading': loading, 'is-danger': isDuplicateNewName}"
              type="text"
              placeholder="Add new name..."
              v-model="newNameInput"
              :disabled="loading"
              @input="$event.target.composing = false"
              @keyup.enter="addName()"
            >
            <div
              @click="addName()"
              v-bind:class="{'is-loading': loading}"
              class="button is-info is-fullwidth mt-3 mb-3"
              :disabled="newNameInput.trim().length === 0 || loading || isDuplicateNewName"
            >
              Add name
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { masterFunction } from '@/firebase/init'
import DeleteName from '@/components/DeleteName'
import EditName from '@/components/EditName'

export default {
  name: 'SetName',
  components: {
    DeleteName,
    EditName
  },
  data() {
    return {
      loading: false,
      newNameInput: '',
      currentView: 'list',
      selectedName: null
    }
  },
  methods: {
    setName(name) {
      if (!this.loading) {
        this.$store.commit('updateName', name)
        this.$emit('closeShowSetNameScreen')
      }
    },
    addName() {
      if (!this.loading && !this.isDuplicateNewName && this.newNameInput.trim().length > 0) {
        this.loading = true
        masterFunction({
          methodName: 'add-name',
          eventId: this.event.eventId,
          name: this.newNameInput.trim(),
          adminKey: this.$store.state.adminKey
        }).then(() => {
          this.$store.commit('updateName', this.newNameInput.trim())
          this.$emit('closeShowSetNameScreen')
          this.newNameInput = ''
          this.loading = false
        }).catch(err => {
          console.log(err)
          this.loading = false
        })
      }
    },
    startEdit(name) {
      if (!this.loading) {
        this.selectedName = name
        this.currentView = 'edit'
      }
    },
    startDelete(name) {
      if (!this.loading) {
        this.selectedName = name
        this.currentView = 'delete'
      }
    },
    backToList() {
      this.currentView = 'list'
      this.selectedName = null
    }
  },
  computed: {
    event() {
      return this.$store.state.event
    },
    isDuplicateNewName() {
      return (
        this.event &&
        !this.event.names.every(name => name !== this.newNameInput)
      )
    }
  }
}
</script>

<style scoped>
.name-select-btn {
  justify-content: flex-start;
}
</style>
